const initialState = {};

export default (state = initialState, action) => {
	switch (action.type) {
		// LOAD
		case "TRAINING_EDUCATION_ARE_LOADING":
			return {
				...state,
				isLoading: 1
			};
		case "TRAINING_EDUCATION_HAS_ERROR":
			return {
				...state,
				isLoading: 0,
				error: action.error
			};
		case "TRAINING_EDUCATION_SUCCESS":
			return {
				...state,
				sessions: action.data,
				isLoading: 0
			};

		// SIGNUP
		case "TRAINING_EDUCATION_SIGNUP_IS_LOADING":
			const loadingBaseStateSignup = resetSignupState(state);

			return {
				...loadingBaseStateSignup,
				signupInProcess: 1
			};
		case "TRAINING_EDUCATION_SIGNUP_HAS_ERROR":
			return {
				...state,
				signupInProcess: 0,
				signupError: action.error
			};
		case "TRAINING_EDUCATION_SIGNUP_SUCCESS":
			return {
				...state,
				signupSuccess: action.data.message,
				signupInProcess: 0
			};

		case "TRANING_EDUCATION_SIGNUP_RESET":
			const basicStateSignup = resetSignupState(state);

			return { ...basicStateSignup };

		// CANCEL
		case "TRAINING_EDUCATION_CANCEL_IS_LOADING":
			const loadingBaseStateCancel = resetCancelState(state);

			return {
				...loadingBaseStateCancel,
				cancelInProcess: 1
			};
		case "TRAINING_EDUCATION_CANCEL_HAS_ERROR":
			return {
				...state,
				cancelInProcess: 0,
				cancelError: action.error
			};
		case "TRAINING_EDUCATION_CANCEL_SUCCESS":
			return {
				...state,
				cancelSuccess: action.data.message,
				cancelInProcess: 0
			};

		case "TRANING_EDUCATION_CANCEL_RESET":
			const basicStateCancel = resetCancelState(state);

			return { ...basicStateCancel };

		default:
			return state;
	}
};

/**
 * Returns only the basic necessity of state without all of the errors, success, etc. (in regards to signup)
 * @param object state
 */
function resetSignupState(state) {
	const { signupError, signupSuccess, ...newState } = state;
	return newState;
}

/**
 * Returns only the basic necessity of state without all of the errors, success, etc. (in regards to cancelling a signup)
 * @param object state
 */
function resetCancelState(state) {
	const { cancelError, cancelSuccess, ...newState } = state;
	return newState;
}



// WEBPACK FOOTER //
// ./src/store/reducers/trainingEducation.js